<template>
  <div class="card">
    <div class="card-body">
      <!-- Загрузка изображения -->
      <b-form-group label="Загрузка изображения схемы">
        <file-uploader
          :key="'schemeRouteFile'"
          :default="localSchemeRouteFile"
          :value="localSchemeRouteFileId"
          @input="val => (localSchemeRouteFileId = val)"
        />
      </b-form-group>

      <!-- Iframe карты -->
      <b-form-group label="Вставьте iframe карты (например, Google или Яндекс)">
        <a
          href="https://yandex.ru/map-constructor/"
          target="_blank"
        >
          Конструктор схемы
        </a>

        <b-form-textarea
          v-model="localSchemeRouteIframe"
          placeholder="<iframe ...></iframe>"
          rows="4"
        />

        <b-button
          variant="primary"
          class="mt-1"
          @click="togglePreview"
        >
          {{ localShowIframePreview ? 'Скрыть' : 'Предпросмотр' }}
        </b-button>

        <div
          v-if="localShowIframePreview"
          class="iframe-preview mt-2"
        >
          <div v-html="localSchemeRouteIframe"></div>
        </div>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import { BFormGroup, BFormTextarea, BButton } from 'bootstrap-vue'

import FileUploader from '@/global-components/FileUploader.vue'

export default {
  name: 'SchemeRouteSection',

  components: {
    BFormGroup,
    BFormTextarea,
    BButton,
    FileUploader,
  },

  props: {
    schemeRouteFile: { type: [Object, String, null], default: null },
    schemeRouteFileId: { type: [Number, String, null], default: null },
    schemeRouteIframe: { type: String, default: '' },
    showIframePreview: { type: Boolean, default: false },
  },

  computed: {
    localSchemeRouteFile: {
      get() {
        return this.schemeRouteFile
      },
      set(val) {
        this.$emit('update:schemeRouteFile', val)
      },
    },

    localSchemeRouteFileId: {
      get() {
        return this.schemeRouteFileId
      },
      set(val) {
        this.$emit('update:schemeRouteFileId', val)
      },
    },

    localSchemeRouteIframe: {
      get() {
        return this.schemeRouteIframe
      },
      set(val) {
        this.$emit('update:schemeRouteIframe', val)
      },
    },

    localShowIframePreview: {
      get() {
        return this.showIframePreview
      },
      set(val) {
        this.$emit('update:showIframePreview', val)
      },
    },
  },

  methods: {
    togglePreview() {
      this.localShowIframePreview = !this.localShowIframePreview
    },
  },
}
</script>

<style scoped lang="scss">
.iframe-preview {
  width: fit-content;
}
</style>
